<template>
  <div class="noBreak">
    <!-- 日期型 -->
    <template v-if="type == 'date'">
      <a-date-picker placeholder="请选择" style="width:100%;" valueFormat="YYYY-MM-DD" v-model="inputValue" />
    </template>
    <!-- 整型 -->
    <template v-if="['float', 'decimal', 'long'].includes(type)">
      <a-input-number placeholder="请输入" style="width:100%;" v-model="inputValue" />
    </template>
    <!-- 百分比类型 -->
    <template v-if="type == 'percent'">
      <a-input addon-after="%" placeholder="请输入" v-model="inputValue" />
    </template>
    <!-- 布尔型 -->
    <template v-if="type == 'boolean'">
      <k-switch v-model="inputValue"></k-switch>
    </template>
    <!-- 周期型 -->
    <template v-if="type == 'period'">
      <k-period-input v-model="inputValue" />
    </template>
    <!-- 其他类型 -->
    <template v-if="['float', 'decimal', 'string', '0', '1', '2', '3'].includes(type)">
      <a-input placeholder="请输入" v-model="inputValue" />
    </template>
  </div>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String | Number | Boolean | Array | Object,
      default: () => {}
    },
    type: {
      type: String,
      default: 'string'
    }
  },
  data() {
    return {
      periodType: ['每周', '每月', '每季', '每年']
    };
  },
  created() {},
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('change', value);
      }
    }
  },
  methods: {
    change() {}
  }
};
</script>
<style lang="less">
.noBreak {
  height: 32px;
  overflow: hidden;
}
</style>
